import { CashFlowAndPerformanceStatistics } from "@rentablo/api/apiv1";

export interface PortfolioStatistics {
  changeTotal: number;
  changeTotalAbsolute: number;
  changeYTD: number;
  changeYTDAbsolute: number;
  changeToday: number;
  changeTodayAbsolute: number;
  portfolioValue: number;
  hasData: boolean;
}

export const portfolioStatistics = (
  cfStats?: CashFlowAndPerformanceStatistics
): PortfolioStatistics => {
  const twror = cfStats?.twrorResults;
  const portfolioValue = twror ? twror[twror?.length - 1]?.portfolioValue : 0;

  return {
    changeTotal: cfStats?.changeTotal?.performance ?? 0,
    changeTotalAbsolute: cfStats?.changeTotal?.changeAbsCashFlowAdjusted ?? 0,
    changeYTD: cfStats?.changeYTD?.performance ?? 0,
    changeYTDAbsolute: cfStats?.changeYTD?.changeAbsCashFlowAdjusted ?? 0,
    changeToday: cfStats?.changeToday?.performance ?? 0,
    changeTodayAbsolute: cfStats?.changeToday?.changeAbsCashFlowAdjusted ?? 0,
    portfolioValue: portfolioValue ?? 0,
    hasData: !!cfStats?.hasData,
  };
};
